import { useState, useRef, useEffect } from "react";
import { Globe, Check } from "lucide-react";
import { LANGUAGES, useT } from "../lib/i18n";

export default function LanguageSwitcher({ compact = false }) {
    const { lang, changeLang } = useT();
    const [open, setOpen] = useState(false);
    const ref = useRef(null);
    const current = LANGUAGES.find((l) => l.code === lang) || LANGUAGES[0];

    useEffect(() => {
        const onClick = (e) => {
            if (ref.current && !ref.current.contains(e.target)) setOpen(false);
        };
        document.addEventListener("mousedown", onClick);
        return () => document.removeEventListener("mousedown", onClick);
    }, []);

    return (
        <div className="relative" ref={ref}>
            <button
                onClick={() => setOpen((v) => !v)}
                className="inline-flex items-center gap-1.5 px-3 py-2 rounded-xl text-sm font-medium text-stone-600 hover:bg-bone-2 transition-colors"
                data-testid="lang-switcher-btn"
                aria-label="Change language"
            >
                <Globe size={16} />
                <span>{current.flag}</span>
                {!compact && <span className="hidden sm:inline">{current.label}</span>}
            </button>
            {open && (
                <div
                    className="absolute right-0 top-full mt-1 w-44 bg-white border border-soft rounded-xl shadow-lg py-1 z-50"
                    data-testid="lang-switcher-menu"
                >
                    {LANGUAGES.map((l) => (
                        <button
                            key={l.code}
                            onClick={() => {
                                changeLang(l.code);
                                setOpen(false);
                            }}
                            className={`w-full flex items-center gap-2 px-3 py-2 text-sm hover:bg-bone-2 transition-colors ${
                                l.code === lang ? "text-forest font-medium" : "text-stone-600"
                            }`}
                            data-testid={`lang-option-${l.code}`}
                        >
                            <span className="text-base">{l.flag}</span>
                            <span className="flex-1 text-left">{l.label}</span>
                            {l.code === lang && <Check size={14} className="text-forest" />}
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
}
